import { Configure, Index, useHits, useInstantSearch, useSearchBox } from "react-instantsearch";
import { VirtualSearchBox } from "../../search-shared/VirtualSearchBox";
import { searchIndexes } from "../../search-shared/client";
import { Skeleton } from "../../search-results/components/ui/Skeleton";
import SimpleResult from "./SimpleResult";
import NoResults from "../../search-results/components/NoResults";
import { capitalizeFirstLetter } from "../../utils/capitalise";
import { ScrollArea } from "../../components/ui/ScrollArea";

function TheHits() {
  const { status } = useInstantSearch();
  const { items } = useHits();

  const onSelect = (query: string) => {
      const baseUrl = window.location.origin;
      window.location.href = `${baseUrl}/search?query=${query}`;
  }

  if (status === "loading" || status === "stalled") {
      return Array(4).fill(null).map((_, index) => (
          <Skeleton key={index} className="h-[21px] mx-2 my-1 bg-gray-200" />
      ))
  }

  if (!items.length) {
    return <NoResults />;
  }

  return <>
    <ScrollArea orientation="horizontal" thumbBgColor="tw-bg-transparent" className="tw-max-w-full tw-pb-3">
      <div className="tw-inline-flex lg:tw-block tw-space-x-3 lg:tw-space-x-0 lg:tw-space-y-1 tw-text-lg lg:[&_*]:tw-text-base [&_*]:tw-underline lg:[&_*]:tw-no-underline hover:[&_*]:tw-no-underline hover:[&_*]:tw-text-black">
        {items.map((item) => (
          <SimpleResult key={item.objectID} onSelect={onSelect} text={capitalizeFirstLetter(item.query)} />
        ))}
      </div>
    </ScrollArea>
  </>;
}

export function QuerySuggestions() {
  const { suggestions_autocomplete_hits_per_page = 7 } = window.algoliaShopify.config;
  const { query } = useSearchBox();
  const title = query ? "Query Suggestions" : "Popular Searches";

  return (
    <Index indexName={searchIndexes.SUGGESTIONS}>
        <VirtualSearchBox />
        <Configure
            hitsPerPage={suggestions_autocomplete_hits_per_page}
            query={query || "*"}
        />
        <div className="tw-mt-10 tw-mb-5 lg:tw-mb-0 tw-flex tw-flex-col tw-text-search-grey lg:tw-text-black">
            <div className="tw-space-y-1 lg:tw-space-y-2">
              <h2 className="tw-text-sm lg:tw-text-lg">{title}</h2>
              <TheHits />
            </div>
        </div>
    </Index>
  )
};